<div class="signupContent">
    <form>
        <div class="form-group">
            <div class="inner-addon left-addon">
                <i class="glyphicon flaticon-manager pull-right"></i>
                <input id="lastname" class="form-control" [(ngModel)]="customer.lastname" spellcheck=false name="lastname" type="text" size="18"
                    alt="login" required="">
                <span class="form-highlight"></span>
                <span class="form-bar"></span>
                <label for="lastname" class="float-label">Nom</label>
            </div>
        </div>
        <div class="form-group">
            <div class="inner-addon left-addon">
                <i class="glyphicon  flaticon-phone-symbol-of-an-auricular-inside-a-circle pull-right"></i>
                <input id="phone" class="form-control" [(ngModel)]="customer.phone" spellcheck=false name="phone" type="tel" size="10" alt="login"
                    required="">
                <span class="form-highlight"></span>
                <span class="form-bar"></span>
                <label for="phone" class="float-label">Téléphone portable</label>
            </div>
        </div>
        <div id="u" class="form-group">
            <div class="inner-addon left-addon">
                <i class="glyphicon flaticon-gmail-logo pull-right"></i>
                <input id="username" spellcheck=false class="form-control" [(ngModel)]="customer.email" name="username" type="text" size="18"
                    alt="login" required="">
                <span class="form-highlight"></span>
                <span class="form-bar"></span>
                <label for="username" class="float-label">E-mail</label>
            </div>
        </div>
        <div class="form-group">
            <div class="inner-addon left-addon pass">
                <input id="password" class="form-control" [(ngModel)]="customer.password" spellcheck=false name="password" type="password"
                    size="18" alt="login" required="">
                <span class="form-highlight"></span>
                <span class="form-bar"></span>
                <label for="password" class="float-label">Mot de Passe (8 caractères minimum)</label>
            </div>
        </div>
        <div class="form-group">
            <div class="inner-addon left-addon pass">
                <input id="confirmePassword" class="form-control" [(ngModel)]="customer.confirmePassword" spellcheck=false name="confirmePassword" type="password"
                    size="18" alt="login" required="">
                <span class="form-highlight"></span>
                <span class="form-bar"></span>
                <label for="confirmePassword" class="float-label">Confirmation du mot de passe</label>
            </div>
        </div>

        <div class="form-group">
            <p>Après l'inscription, merci de consulter votre boite e-mail pour valider votre inscription.</p>
        </div>
        <div class="form-group text-right">
            <div class="form-btn">
                <div class="wrap-form-btn">
                    <button class="signUp-btn" (click)="signup()" [disabled]="loader">
                            <ng-container *ngIf="loader"><i class='glyphicon glyphicon-refresh spinning'></i>&nbsp;&nbsp;</ng-container>   
                        S'inscrire
                    </button>
                </div>
                <a routerLink="../connexion" class="login-btn">
                    Se connecter &nbsp;&nbsp;
                    <i class="glyphicon glyphicon-arrow-right"></i>
                </a>
            </div>
        </div>
    </form>
</div>